module.exports = require("rxjs/operators/map");


//////////////////
// WEBPACK FOOTER
// external "rxjs/operators/map"
// module id = 875
// module chunks = 0